import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
  TabbedNavigationSubGroup,
} from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { MutualFundsFundOrdersTable } from '../../../../../../../../../../features/mutual-funds/fund-order/mutual-funds-fund-orders-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';
import type { ViewContext } from '../../../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/mutual-fund')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountSummaryList,
      parentTab: TabbedNavigationSubGroup.RegistrationAccountSummaryListOrders,
      label: 'Mutual Funds Orders',
      order: 20, // Subgroup order
    },
  } satisfies PortalTabbedNavigationTab<
    TabbedNavigationGroup.RegistrationAccountSummaryList,
    TabbedNavigationSubGroup.RegistrationAccountSummaryListOrders
  >,
  head: () => getPageHead('Account Mutual Funds Orders'),
  component: AccountMutualFundOrderList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RegistrationAccountSummaryList}
    />
  );
}

function AccountMutualFundOrderList() {
  const { accountId } = Route.useParams();
  const viewContext: ViewContext = useMemo(
    () => ({
      kind: 'account',
      accountId,
    }),
    [accountId],
  );

  return (
    <PageLayout.Section noBorder>
      <MutualFundsFundOrdersTable HeaderActions={TableHeader} viewContext={viewContext} />
    </PageLayout.Section>
  );
}
